import React, { FC, useContext } from "react";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { useQuery } from "@tanstack/react-query";
import { LinearProgress } from "@mui/material";
import HorizontalScroll from "../Common/HorizontalScroll/HorizontalScroll";
import TeamMemberCard from "./TeamMemberCard";
import { formatFilterString } from "../Career/utils/filterutils";
import { fetchGraphQL } from "../../Graphql/utils";
import { getAllEmployeesQuery } from "../../Graphql/querries/employeeQuery";
import { GetEmployeesResponse } from "../../Graphql/types/employee";
import AlertBannerContext from "../../Contexts/alertBannerContext";

interface OurTeamProps {
  hideTitle?: boolean;
}

export const OurTeam: FC<OurTeamProps> = (props) => {
  const { hideTitle } = props;
  const { setAlert } = useContext(AlertBannerContext);
  const { data, error, isFetching } = useQuery<GetEmployeesResponse>({
    queryKey: ["getEmployees"],
    queryFn: () => fetchGraphQL(getAllEmployeesQuery, {}, setAlert)
  });

  if (isFetching) {
    return <LinearProgress />;
  }

  if (error) {
    return <div />;
  }

  return (
    <Stack
      sx={{
        background: "transparent",
        padding: 0,
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box"
      }}
    >
      <Stack
        justifyContent="center"
        spacing="1.3em"
        alignItems="center"
        flexDirection="column"
        padding="2em 0 0 0"
      >
        {!hideTitle && (
          <>
            <Typography variant="h4">Our Team</Typography>
            <Divider textAlign="left">
              <SettingsSuggestIcon color="primary" />
            </Divider>
          </>
        )}
      </Stack>
      <HorizontalScroll>
        {data?.getAllPublicEmployees?.map((t) => (
          <TeamMemberCard
            name={`${t.firstName} ${t.lastName.charAt(0).toUpperCase()}.`}
            email={t.email}
            role={formatFilterString(
              t.hiredEmployeeInfo?.positions?.join(" & ") ?? ""
            )}
            photoUrl={t.hiredEmployeeInfo?.avatar}
            linkedInUrl={t.additionalEmployeeInfo?.linkedInUrl}
          />
        ))}
      </HorizontalScroll>
      <Stack
        padding="0 5%"
        justifyContent="flex-start"
        alignItems="center"
        flexDirection="column"
        sx={{ width: "50%", display: "flex" }}
      >
        <section />
      </Stack>
    </Stack>
  );
};
